import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';


const Drp_StoreRoom = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const Change = (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        props.onChange(event.target.value, event.nativeEvent.target[index].text)


    }
    useImperativeHandle(ref, () => ({

        Bind(Id) {
            trackPromise(
                fetch(General.ApiRoute() + '/StoreRoom/GetAll', {
                    method: 'Get',
                    headers: {
                        'ApiKey': General.APIKey(),
                    },
                    credentials: 'include'
                })
                    .then(res => res.json())
                    .then(result => {
                        var tmp = []
                        for (var i = 0; i < result.length; i++) {
                            if (result[i].isActive == 1) {
                                tmp.push({
                                    Row: i + 1,
                                    Id: result[i].id,
                                    Title: result[i].title,
                                    Code: result[i].code,
                                    IsActive: result[i].isActive,
                                    IsDefault: result[i].isDefault,

                                })
                                if (Id == result[i].id)
                                    props.onChange(result[i].id, result[i].title)

                                else if (result[i].isDefault == 1)
                                    props.onChange(result[i].id, result[i].title)

                            }
                        }
                        setList(tmp)
                    })
            )


        },
        focus() {
            const inputElement = document.querySelector('.FocusItem');
            console.dir(inputElement)
            if (inputElement) {
                inputElement.focus();
            }
        }



    }))



    return (
        <>
            <select className={props.className} onChange={Change} value={props.value} disabled={props.disabled}>
                <option value="-1">انتخاب نمایید</option>
                {
                    List.map(item => (
                        <option value={item.Id}> {item.Title} ({item.Code})  </option>
                    ))
                }

            </select>
        </>
    )
});

export default Drp_StoreRoom;